"use strict";

var _classCallCheck = require("/home/cleysonph/playground/TypeScript-Website/node_modules/gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/cleysonph/playground/TypeScript-Website/node_modules/gatsby/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var OnigScanner_1 = require("./OnigScanner");

var OnigRegExp = /*#__PURE__*/function () {
  /**
   * Create a new regex with the given pattern
   * @param source A string pattern
   */
  function OnigRegExp(source) {
    _classCallCheck(this, OnigRegExp);

    this.source = source;

    try {
      this.scanner = new OnigScanner_1.default([this.source]);
    } catch (error) {// doesn't make much sense, but this to pass atom/node-oniguruam tests
    }
  }
  /**
   * Synchronously search the string for a match starting at the given position
   * @param string The string to search
   * @param startPosition The optional position to start the search at, defaults to `0`
   */


  _createClass(OnigRegExp, [{
    key: "searchSync",
    value: function searchSync(string, startPosition) {
      var match;

      if (startPosition == null) {
        startPosition = 0;
      }

      match = this.scanner.findNextMatchSync(string, startPosition);
      return this.captureIndicesForMatch(string, match);
    }
    /**
     * Search the string for a match starting at the given position
     * @param string The string to search
     * @param startPosition The optional position to start the search at, defaults to `0`
     * @param callback The `(error, match)` function to call when done, match will be null if no matches were found. match will be an array of objects for each matched group on a successful search
     */

  }, {
    key: "search",
    value: function search(string, startPosition, callback) {
      if (startPosition == null) {
        startPosition = 0;
      }

      if (typeof startPosition === 'function') {
        callback = startPosition;
        startPosition = 0;
      }

      try {
        var ret = this.searchSync(string, startPosition);
        callback(null, ret);
      } catch (error) {
        callback(error);
      }
    }
    /**
     * Synchronously test if this regular expression matches the given string
     * @param string The string to test against
     */

  }, {
    key: "testSync",
    value: function testSync(string) {
      if (typeof this.source === 'boolean' || typeof string === 'boolean') {
        return this.source === string;
      }

      return this.searchSync(string) != null;
    }
    /**
     * Test if this regular expression matches the given string
     * @param string The string to test against
     * @param callback The (error, matches) function to call when done, matches will be true if at least one match is found, false otherwise
     */

  }, {
    key: "test",
    value: function test(string, callback) {
      if (typeof callback !== 'function') {
        callback = function callback() {};
      }

      try {
        callback(null, this.testSync(string));
      } catch (error) {
        callback(error);
      }
    }
  }, {
    key: "captureIndicesForMatch",
    value: function captureIndicesForMatch(string, match) {
      if (match != null) {
        var captureIndices = match.captureIndices;
        var capture;
        string = this.scanner.convertToString(string);

        for (var i = 0; i < captureIndices.length; i++) {
          capture = captureIndices[i];
          capture.match = string.slice(capture.start, capture.end);
        }

        return captureIndices;
      } else {
        return null;
      }
    }
  }]);

  return OnigRegExp;
}();

exports.default = OnigRegExp;